/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DatatableConfiguration {
    getFixupPrototypeFunction() { return DatatableConfiguration.fixupPrototype; }

    static newInstance(model: Partial<DatatableConfiguration>): DatatableConfiguration {
        let obj = Object.assign(new DatatableConfiguration(), model);
        DatatableConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DatatableConfiguration>): DatatableConfiguration {
        if (!model) return null;
        return DatatableConfiguration.newInstance(<DatatableConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DatatableConfiguration) {
        if (!obj) return;

        models.DatatableConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DatatableConfiguration): boolean {
        Object.setPrototypeOf(obj, DatatableConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.columns) {
            for (let val of this.columns) {
                models.DatatableColumnConfiguration.fixupPrototype(val);
            }
        }
    }

    columns: Array<models.DatatableColumnConfiguration>;

}
